import HomePopup from "../Dashboard_PopUp/HomePopup";
import "./Header.css";
//import { Globals } from "../../global/Globals";
import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { deleteCookie, formatclusterandroleName, formatRoleName, getCookie } from "../../util/util";
import { downloadFile, logoutUser } from "../../services/GenericAPI";
import { useCluster } from "../../pages/ClusterContext/ClusterContext";
import { fetchProducer } from "../../services/api";
import CryptoUtils from "../../util/cryptoUtils";
//import { unauthorizedHandler } from "../../context/Unauthorisedcontext";
import { useRole } from "../../context/Rolecontext";
import LanguageSelector from "../../components/LanguageSelector/LanguageSelector";
import { useLanguage } from "../../context/Languagecontext";

export default function Header({ ...props }) {
  const { Globals, languages } = useLanguage();
  const navigate = useNavigate();
  const profileRefer = useRef(null);
  const { onlyPicture, route, onTabClick, notificationsLength } = props;
  const [activeTab, setActiveTab] = useState(route);
  const [isDashboardOpen, setIsDashboardOpen] = useState(true);
  const isProducer = CryptoUtils.getFromLocalStorage("isProducer")?.toString() === "true";
  const roleId = CryptoUtils.getFromLocalStorage("roleId")?.toString();
  const userType = CryptoUtils.getFromLocalStorage("userType");
  const allClusters = JSON.parse(CryptoUtils.getFromLocalStorage("clusters"));
  const firstCluster = JSON.parse(CryptoUtils.getFromLocalStorage("clusterName"));
  const allRoles= JSON.parse(CryptoUtils.getFromLocalStorage("roles"));
  const [selectedClusterId, setSelectedClusterId] = useState(
    firstCluster?.[0] && firstCluster[0]?.clusterId
  );
  const [selectedRole, setSelectedRole] = useState(roleId);
  const [selectedRoleName,setSelectedRoleName] =useState();
  const { updateCluster } = useCluster();
const {updateRole} = useRole();

useEffect(() => {
  if (!allRoles || !selectedRole) return;
  const matchedRole = allRoles.find(
    (role) => parseInt(selectedRole) === role?.roleId
  );
  if (matchedRole) {
    setSelectedRoleName(matchedRole.roleName);
  }
}, [allRoles, selectedRole]);

  const toggleDashboard = () => {
    setIsDashboardOpen(!isDashboardOpen);
  };
  const isActive = (tab) => activeTab === tab;

  const activeStyle = {
    fontWeight: "800",
    color: "var(--surface-primary-default, #004894)",
    textDecoration: "none",
  };
  const defaultStyle = { fontWeight: "normal", color: "black", textDecoration: "none" };
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [logoDetails, setLogoDetails]=useState({name:'', downloadPath:''});
  const [logoSource, setLogoSource]=useState('');
  function headerNavgation(header) {
    setActiveTab(header);
    if (onTabClick) {
      onTabClick(header);
    } else {
      navigate("/home", { state: { activeHeader: header } });
    }
  }
  useEffect(() => {
    if (route) setActiveTab(route);
  }, [route]);
  
  useEffect(() => {
    const isLoggedIn = !!CryptoUtils.getFromLocalStorage("JWT_TOKEN_NAME");
    if (!isLoggedIn) {
      navigate(Globals.NAVPATH.LOGIN);
    }
  }, [navigate]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileRefer.current && !profileRefer.current.contains(event.target)) {
        setIsProfileOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (roleId === Globals.USER_ROLES.PRODUCER) {
      fetchProducerData();
    }

  }, []);
   useEffect(() => {
    if (roleId === Globals.USER_ROLES.PRODUCER) {
      fetchProducerData();
    }

  }, [languages]);

  const fetchProducerData = async () => {
    try {
      const data = await fetchProducer();

      if (!data || !data.content || !data.content.producer || !data.content.documents) {
        console.error("Invalid data structure received from API:", data);
        return;
      }
      const documents = data?.content?.documents;
      //Logo
      const logoFileName = documents?.find(file => file?.documentFor === 'PLOGO' || file?.documentFor === null)?.documentName;
      const logoFileDPath = documents?.find(file => file?.documentFor === 'PLOGO' || file?.documentFor === null)?.documentPath;
      setLogoDetails({ name: logoFileName, downloadPath: logoFileDPath });

    } catch (error) {
      console.error('Error fetching producer data:', error);
    }
  }

  const handleNavigation = () => {
    if (userType === "internal" && roleId === "4" && !isProducer) {
      return;
    }
    navigate(
      userType === "Individual" && roleId === "5" && isProducer
        ? Globals.NAVPATH.PRODUCERPROFILE
        : userType === "Company" && roleId === "5" && isProducer
        ? Globals.NAVPATH.COMPANYPROFILE
        : null
    );
  };

  const handleLogout = () => {
     const accessToken = CryptoUtils.getFromCookie(Globals.JWT_TOKEN_NAME);
    logoutUser()
      .then((response) => {
        if (response.data.status === "OK") {
           localStorage.clear();
           deleteCookie(Globals.JWT_TOKEN_NAME);
           window.location.href = '/';
        } else {
          console.error("Error in logout : ", response?.reasonPhrase);
        }
      })
      .catch((error) => {
        console.error("Error in logout : ", error);
      });
  };

  const handleButtonClick = (clusterId, clusterName) => {
    setSelectedClusterId(clusterId);
    updateCluster(clusterId, clusterName);
  };

  const handleRoleSelection = (roleId, roleName) => {
    setSelectedRole(roleId);
    updateRole(roleId, roleName);
  };

  const toggleProfile = () => {
    setIsProfileOpen(!isProfileOpen);
    if(logoDetails.downloadPath){
      getLogoSource();
    }
  };
  const getLogoSource = async () => {
    try {
      const isForProducer = true;
      const response = await downloadFile(logoDetails.downloadPath, isForProducer);
 
      if (response?.data) {
        const blob = new Blob([response.data],{ type: response.headers['Content-Type'] });
        const fileUrl = URL.createObjectURL(blob);
        setLogoSource(fileUrl);
        setTimeout(() => URL.revokeObjectURL(fileUrl), 5000);
      } else {
        console.error("Error: No file data available for download.");
      }
    } catch (error) {
      console.error("Error in downloading the file:", error);
    }
  };

  useEffect(()=>{
    if(logoDetails.downloadPath){
      getLogoSource();
    }
  },[logoDetails.downloadPath])

   //Reset activeTab if it's not valid for the current role
   useEffect(() => {
    const isRequestsAvailable = roleId === "2" || roleId === "6";

    if ((activeTab === "requests") && !isRequestsAvailable) {
      const fallback =  
        roleId === "5" ? "dashboard" :
        roleId === "1" ? "admin" :
        roleId === "2" || roleId === "3" || roleId === "4" || roleId === "6" ? "internal_dashboard" :
        "dashboard"; 

      setActiveTab(fallback);
      headerNavgation(fallback);
    }
  }, [roleId, activeTab]);


  return (
    <div className="Header-Outer-Wrapper">
      <div className="Header-Inner-Wrapper">
        {!onlyPicture ? (
          <>
            <div className="left-item">
              <img src={Globals.IMG.BACKGROUND_LOGO} width={247} height={40} />
            </div>
            <div class={`center-item centerItem-${languages}-${roleId}`}>
              <div
                onClick={() => {
                  const destination =
                    roleId === "5"
                      ? "dashboard"
                      : roleId === "1"
                      ? "admin"
                      : roleId === "2" || roleId === "3" || roleId === "4" || roleId === "6"
                      ? "internal_dashboard"
                      : "";
                  headerNavgation(destination);
                }}
                class="center-right cursor"
                style={
                  isActive("dashboard") ||
                  isActive("internal_dashboard") ||
                  (isActive("admin") && isDashboardOpen)
                    ? activeStyle
                    : defaultStyle
                }
              >
                {roleId === "5"
                  ? Globals.HEADER.DASHBOARD
                  : roleId === "1"
                  ? Globals.HEADER.DASHBOARD
                  : roleId === "2" || roleId === "3" || roleId === "4" || roleId === "6"
                  ? Globals.HEADER.DASHBOARD
                  : ""}
              </div>

              <div
                onClick={() => {
                  const destination =
                    roleId === "5"
                      ? "proposals"
                      : roleId === "1"
                      ? "internal_management"
                      : roleId === "2" || roleId === "3" || roleId === "4" || roleId === "6"
                      ? "all_proposals"
                      : "";
                  headerNavgation(destination);
                }}
                class="center-left cursor"
                style={
                  isActive("proposals") ||
                  isActive("all_proposals") ||
                  (isActive("internal_management") && isDashboardOpen)
                    ? activeStyle
                    : defaultStyle
                }
              >
                {roleId === "5"
                  ? Globals.HEADER.MYPROPOSALS
                  : roleId === "1"
                  ? Globals.HEADER.INTERNALMANAGEMENT
                  : roleId === "2" || roleId === "3" || roleId === "4" || roleId === "6"
                  ? Globals.HEADER.ALLPROPOSALS
                  : ""}
              </div>{" "}

              {(roleId == "2" || roleId =="6") && (
                <div
                  onClick={() =>
                    headerNavgation("requests")
                  }
                  class="center-left cursor"
                  style={
                    isActive("requests")
                      ? activeStyle
                      : defaultStyle
                  }
                >
                  {Globals.HEADER.REQUESTS}
                </div>
              )}
              {(roleId == "2" || roleId == "1" || roleId =="6" || roleId == "3" || roleId == "4") && (
                <div
                  onClick={() =>
                    headerNavgation("auditTrails")
                  }
                  class="center-left cursor"
                  style={
                    isActive("auditTrails")
                      ? activeStyle
                      : defaultStyle
                  }
                >
                  {Globals.HEADER.AUDITTRAIL}
                </div>
              )}
            </div>
            <div class="right-item">
              {/* {roleId === "5" && */}
             <LanguageSelector ishome={false} /> 
              {/* } */}
             
              <HomePopup
                notificationsLength={notificationsLength}
                togglePop={toggleDashboard}
                route={route}
              />

              <div ref={profileRefer} className="profile-wrapper cursor" onClick={(e) => {e.stopPropagation();toggleProfile();}}>
                <img src={logoSource || Globals.IMG.PROFILE_ICON} className="profile-photo" style={{ width: '50px', height: '40px' }} />
                <div className="profile-details">
                  <span className="profile-name">{CryptoUtils.getFromLocalStorage("fullName")}</span>
                  <span className="profile-company">{CryptoUtils.getFromLocalStorage("companyName")}</span>
                  {roleId !== '1' && roleId !== '5' && 
                  <div className="roleCluster_profile">
                  <span className="profile-company">{formatRoleName(selectedRoleName)}</span>
                  <div className="rolecluster-sepearator"></div>
                  {roleId !== '1' && roleId !== '5' && <div className="profile-company clustername-profile selectedCluster" title={JSON.parse(CryptoUtils.getFromLocalStorage("clusterName"))?.[0]?.clusterName}>{Globals.CLUSTERNAME[formatclusterandroleName(JSON.parse(CryptoUtils.getFromLocalStorage("clusterName"))?.[0]?.clusterName)]}</div>}
                  {!CryptoUtils.getFromLocalStorage("companyName") && CryptoUtils.getFromLocalStorage("userType") === "Individual" && <span className="profile-company">{Globals.FILTER.PRODUCER}</span>}
                  </div>}
                </div>
                {isProfileOpen && (
                  <div className={(roleId !== '1' && roleId !== '5') ? "popup-profile1-box" : "popup-profile2-box"}>
                    <div className="profile-dropdown">
                      <div className="profile-dropdown-wrapper cursor" onClick={handleNavigation}>
                        <img
                          src={logoSource || Globals.IMG.PROFILE_ICON}
                          className="profile-photo1"
                          style={{ width: '50px', height: '40px' }}
                        />
                        <div className="profile-details">
                          <span className="profile-name">
                            {CryptoUtils.getFromLocalStorage("fullName")
                              ? CryptoUtils.getFromLocalStorage("fullName")
                              : ""}
                          </span>
                          <span className="profile-company">
                            {CryptoUtils.getFromLocalStorage("companyName")
                              ? CryptoUtils.getFromLocalStorage("companyName"): ""}
                          </span>
                          {roleId !== '1' && roleId !== '5' && <span className="profile-company">
                            {CryptoUtils.getFromLocalStorage("clusterName")
                              ? Globals.CLUSTERNAME[formatclusterandroleName(JSON.parse(CryptoUtils.getFromLocalStorage("clusterName"))[0].clusterName)]
                              : ""}
                          </span>}
                          {!CryptoUtils.getFromLocalStorage("companyName") &&  CryptoUtils.getFromLocalStorage("userType") === "Individual" && <span className="profile-company">{Globals.FILTER.PRODUCER}</span>}
                        </div>
                      </div>
                      {allRoles && allRoles?.length > 0 && roleId !== "5" && roleId !== "1" && roleId!=="6" && (
                         <div className="profile-cluster-wrap">
                         <div className="cluster-title-wrap">
                           <span className="cluster-title">
                            {Globals.HEADER.ROLE}
                           </span>
                         </div>
                         <ul className="cluster-list-wrap">
                            {allRoles?.map((role, index) => (
                              <div>
                                <li classname="cluster-name" key={role?.clusterId}>
                                  <button
                                    className={`cluster-name-button ${
                                      index === allRoles?.length - 1 ? "last-button" : ""
                                    }`}
                                    onClick={() =>
                                      handleRoleSelection(role?.roleId, role?.roleName)
                                    }
                                  >
                                    {Globals.ROLENAME[formatclusterandroleName(role?.roleName,"Role")]}{" "}
                                    {parseInt(selectedRole) === role?.roleId && (
                                      <div className="blue-check-wrapper">
                                        <img className="blue-check" src={Globals.IMG.BLUE_CHECK} />
                                      </div>
                                    )}
                                  </button>
                                </li>
                              </div>
                            ))}
                          </ul>
                        </div>
                      )}
                      
                      {allClusters && allClusters?.length > 0 && roleId !== "5" && roleId !== "1" && (
                        <div className="profile-cluster-wrap">
                          <div className="cluster-title-wrap">
                            <span className="cluster-title">
                              {Globals.UNSOLICITED_PROPOSAL_HALF.CLUSTER}
                            </span>
                          </div>
                          <ul className="cluster-list-wrap">
                            {allClusters?.map((cluster, index) => (
                              <div>
                                <li classname="cluster-name" key={cluster?.clusterId}>
                                  <button
                                    className={`cluster-name-button ${
                                      index === allClusters?.length - 1 ? "last-button" : ""
                                    }`}
                                    onClick={() =>
                                      handleButtonClick(cluster.clusterId, cluster.clusterName)
                                    }
                                  >
                                    <div className={`clusterName-${languages}`}>{Globals.CLUSTERNAME[formatclusterandroleName(cluster?.clusterName,"Cluster")]}{" "}</div>
                                    {selectedClusterId === cluster?.clusterId && (
                                      <div className="blue-check-wrapper">
                                        <img className="blue-check" src={Globals.IMG.BLUE_CHECK} />
                                      </div>
                                    )}
                                  </button>
                                </li>
                              </div>
                            ))}
                          </ul>
                        </div>
                      )}
                      

                      <div className="logout-item cursor" onClick={handleLogout}>
                        <img className="logout-image" src={Globals.IMG.LOGOUT} alt="Logout" />
                        <span className="cursor logout-title" to="#">
                          {Globals.HEADER.LOGOUT}
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="center-item-background">
              <img src={Globals.IMG.BACKGROUND_LOGO} width={247} height={40} />
            </div>
          </>
        )}
      </div>
    </div>
  );
}
